<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted, watch } from "vue";
import router from "@/router";
import { useStore } from "vuex";
import {useRoute} from "vue-router";
import { setHaptic } from "@/tools/setTelegramHaptick";
import { setBackButton, hideBackButton, setBottomButton, hideBottomButton } from '@/tools/setTelegramButtons';
import { getCookingAct } from '@/composables/receivingWorker';
import { createPopupManager } from '@/tools/setTelegramPopUp'
import CartPieceItem from "@/components/mobile/telegram/work_pieces/CartPieceItem.vue";
import Product from "@/models/product";

const point_id = ref<string>('');
const store = useStore();
const editRef = ref(false);
const inputRefComment = ref<HTMLInputElement | null>(null);
let mainButtonListener: (() => void) | null = null;
const popupManager = createPopupManager();

const handleMainButton = async () => {
  setHaptic();
  if (editRef.value === true) {
    editRef.value = !editRef.value;
    setBottomButton('Заказать', '31B545', 'FFFFFF', handleMainButton)
    return;
  }
  if (cartItems.value.length !== 0){
    await createAct();
  }
  else {
    router.go(-1)
  }
};

onMounted(async() => {
  setBackButton();
  point_id.value = String(useRoute().query.point_id);
  hideBottomButton();
  mainButtonListener = handleMainButton;
  if(cartItems.value.length === 0) {
    setBottomButton('Создать акт', '31B545', 'FFFFFF', handleMainButton)
    setBottomButton('К заготовкам', '31B545', 'FFFFFF', handleMainButton)
  }
})

onUnmounted(() => {
  hideBackButton();
  hideBottomButton();
});

//Функция редактирования корзины
const editCart = () => {
  setHaptic();
  editRef.value = !editRef.value;
  setBottomButton('Подтвердить', '31B545', 'FFFFFF', handleMainButton)
}

function noneClick() {
  console.log('click')
}

//Создать акта
async function createAct() {
  setBottomButton('Ждём подтверждения', '31B545', 'FFFFFF', null, false, true);

  const data = await getCookingAct(formattedCartItems.value, isProcessed.value as boolean, inputRefComment.value!.value)
  if (data) {
    popupManager.openPopup(`Акт успешно создан`,
      (buttonId) => {
        console.log("Нажата кнопка:", buttonId);
      },
    );
    router.push('/');
    store.dispatch('clearPointCart', point_id.value);
  }
}

//Логика рендера товаров корзины
const cartItems = computed(() => {
  return store.getters.getCartItemsByPoint(point_id.value);
}) 

const isCatrIsEmpty = ref<boolean>(true)

watch(() => cartItems.value, (newVal) => {
  if (newVal.length !== 0) {
    isCatrIsEmpty.value = false
  }
}, {immediate:true})

const formattedCartItems = computed<{ id: number; quantity: number, packagingName: string, packagingId: string }[]>(() =>
  cartItems.value.map((item: Product) => ({
    id: item.id as number,
    quantity: item.quantity as number,
    packagingName: item.packaging[0].name as string,
    packagingId: item.packaging[0].id as string
  }))
);

const isProcessed = ref<boolean | null>(null);

function setStatsuAct(status: boolean) {
  isProcessed.value = status;
  if(cartItems.value.length > 0) {
    setBottomButton('Создать акт', '31B545', 'FFFFFF', handleMainButton)
  }
  else {
    setBottomButton('К заготовкам', '31B545', 'FFFFFF', handleMainButton)
  }
}

</script>

<template>
    <div class="cart-wrapper">
      <div class="cart-head">
        <p class="cart-head__label">Корзина</p>
        <div class="cart-header">
          <p class="name-cart">Заготовки</p>
        </div>
      </div>
      <div v-if="isCatrIsEmpty" class="btn-toshop">
        КОРЗИНА ПУСТА
      </div>
      <div class="check-boxes-wrapper" v-if="!isCatrIsEmpty">
        <p class="made-act-label">Акт:</p>
        <div class="no-processed-wrapper" @click="setStatsuAct(false)">
          <img v-if="isProcessed === false" class="role-checker" src="@/assets/check.svg">
          <img v-else class="role-checker" src="@/assets/uncheck.svg">
          <p>Без проведения</p>
        </div>
        <div class="processed-wrapper" @click="setStatsuAct(true)">
          <img v-if="isProcessed === true" class="role-checker" src="@/assets/check.svg">
          <img v-else class="role-checker" src="@/assets/uncheck.svg">
          <p>С проведением</p>
        </div>
      </div>
      <div class="input-wrapper" v-if="!isCatrIsEmpty">
        <div
          ref="inputRefComment"
          class="text"
          contenteditable="true"
          role="textbox"
          aria-multiline="true"
          placeholder="Добавить комментарий..."
        ></div>
      </div>
      <div v-if="!isCatrIsEmpty" class="cart-items">
        <CartPieceItem v-for="item in cartItems"
          :item="item"
          :point_id="point_id"
          :editRef="editRef"
        />
        <p v-if="!isCatrIsEmpty && !editRef" class="edit-cart" :style="{ color: editRef ? 'var(--orange-color)' : 'var(--green-color)' }" @click="editCart()">{{ editRef ? 'Подтвердить' : 'Редактировать' }}</p>
      </div>
    </div>
</template>

<style scoped>

.no-processed-wrapper, .processed-wrapper {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;
  font-size: 15px;
  box-sizing: border-box;
  padding: 30px 0;
  width: 100%;
}

.no-processed-wrapper {
  box-shadow: 0 0.5px 0 #C8C7CB;
}

.made-act-label {
  font-size: 16px;
  color: #B9B9B9;
  font-weight: 600;
}

.check-boxes-wrapper {
  width: 100%;
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px 20px 0px 20px;
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--drop-shadow-item);
}

.cart-head {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 100%;
  gap: 15px;
  box-sizing: border-box;
  padding: 20px;
  background-color: white;
  border-radius: var(--border-radius);
  position: sticky;
  top: 0px;
  z-index: 1;
  box-shadow: var(--drop-shadow-item);
}

.btn-toshop{
  margin-top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 20px;
  color: black;
}

.text {
  background-color: inherit;
  font-size: 16px;
  padding: 12px 10px;
  font-family: inherit;
  margin: 0;
  border: none;
  outline: none;
  width: 100%;
  min-height: 50px;
  overflow-y: auto;
  word-wrap: break-word;
  white-space: pre-wrap;
  line-height: 1.5;
  box-sizing: border-box;
  text-align: start;
  color: #525252;
}

.text:empty:before {
  content: attr(placeholder);
  color: #B9B9B9;
  pointer-events: none;
}

.text:focus {
  outline: none;
}

.input-wrapper {
  margin-top: 5px;
  width: 100%;
  min-height: 50px;
  background-color: white;
  border-radius: var(--border-radius);
  display: flex;
  padding: 0 20px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: var(--drop-shadow-item);
}

.cart-items{
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  width: 100%;
  /* gap: 15px; */
  box-sizing: border-box;
  background-color: white;
  border-radius: var(--border-radius);
  padding: 0 10px;
  box-shadow: var(--drop-shadow-item);
  margin-bottom: 10px;
}

.edit-cart{
  font-size: 15px;
  color: var(--green-color);
  font-weight: 600;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: white;
  border-radius: var(--border-radius);
  margin-top: 1px;
}

.name-cart{
  font-size: 18px;
  color: black;
  font-weight: 600;
}

.cart-head__label {
  font-size: 16px;
  color: #B9B9B9;
  font-weight: 600;
}

.cart-header{
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.cart-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}

</style>